import { Flex } from 'antd';
import { Icon, IF } from 'common';
import noChat from '../../assets/icons/noChat.svg';
import noData from '../../assets/icons/noData.svg';
import noHistory from '../../assets/icons/noHistory.svg';
import noNotification from '../../assets/icons/noNotification.svg';
import noOrder from '../../assets/icons/noOrder.svg';
import noPrescription from '../../assets/icons/noPrescription.svg';
import noTicket from '../../assets/icons/noTicket.svg';
import cancelImg from '../../assets/order-images/cancelled.svg';
import refundImg from '../../assets/order-images/refund.svg';
import trackImg from '../../assets/order-images/tracking_unavailable.svg';
import {
  AddressIcon,
  AppointmentsIcon,
  BeakerIcon,
  BulbIcon,
  CalenderDashIcon,
  CardTickIcon,
  CasesIcon,
  ClockIcon,
  DispositionIcon,
  FilesIcon,
  FirstAidIcon,
  FollowUpIcon,
  GiftIcon,
  JobIcon,
  LabWorkIcon,
  ListTickIcon,
  MapIcon,
  MessageIcon,
  MicroscopeIcon,
  NoFileIcon,
  NotesIcon,
  OrderIcon,
  PrescriptionCrossIcon,
  ProductsIcon,
  ProductVariantIcon,
  UserCardIcon,
} from '../all-icons/custom-icons';
import { getCurrentTenantSupportEmail } from 'utils';
import styles from './unavailable.module.scss';

const Unavailable = ({
  type,
  alignIcon = 'center',
  extraItems = () => {},
  extraButton = () => {},
  customTitle = null,
  customDesc = null,
  customGap,
  iconWidth,
  titleClassName = 'h4-medium',
  descClassName = 'body-regular',
}) => {
  const icon = () => {
    switch (type) {
      case 'chat':
      case 'doctor-chat':
      case 'support-chat':
        return <img src={noChat} alt="" width={iconWidth} />;
      case 'notification':
        return <img src={noNotification} alt="" />;
      case 'prescription':
        return <img src={noPrescription} alt="" />;
      case 'history':
        return <img src={noHistory} alt="" />;
      case 'current-order':
      case 'weight':
        return <img width={60} src={noOrder} alt="" />;

      case 'order':
      case 'lead-order':
        return (
          <div style={{ color: 'var(--ant-color-primary)' }}>
            <OrderIcon width={36} height={36} />
          </div>
        );
      case 'track':
        return <MapIcon className="primary-text" />;
      case 'completed':
        return <img src={trackImg} alt="" />;
      case 'before-refund':
      case 'after-refund':
        return <img src={refundImg} height={170} alt="" />;
      case 'before-cancel':
      case 'after-cancel':
        return <img src={cancelImg} height={170} alt="" />;
      case 'clock':
        return <ClockIcon style={{ color: 'var(--ant-color-primary)' }} />;
      case 'follow_up':
        return <FollowUpIcon size={40} style={{ color: 'var(--ant-color-primary)' }} />;
      case 'ticket':
        return <img src={noTicket} alt="" />;
      case 'address':
        return <AddressIcon style={{ color: 'var(--ant-color-primary)' }} />;
      case 'credits':
        return (
          <div className="primary-text">
            <GiftIcon size={48} />
          </div>
        );
      case 'lab-records':
        return <NoFileIcon className="primary-text" />;
      case 'lab-orders':
        return <LabWorkIcon strokeWidth={1} width={50} height={50} className="primary-text" />;

      case 'case':
      case 'lead-untrack-cases':
        return (
          <div style={{ color: 'var(--ant-color-primary)' }}>
            <CasesIcon width={36} height={36} />
          </div>
        );
      case 'notes':
        return (
          <div style={{ color: 'var(--ant-color-primary)' }}>
            <NotesIcon />
          </div>
        );
      case 'appointments':
        return (
          <div style={{ color: 'var(--ant-color-primary)' }}>
            <AppointmentsIcon />
          </div>
        );
      case 'products':
        return (
          <div style={{ color: 'var(--ant-color-primary)' }}>
            <ProductsIcon width={28} height={28} />
          </div>
        );
      case 'activity':
        return (
          <div style={{ color: 'var(--ant-color-primary)' }}>
            <BulbIcon width={28} height={28} />
          </div>
        );
      case 'communication':
      case 'admin-chat':
        return <MessageIcon size={40} style={{ color: 'var(--ant-color-primary)' }} />;
      case 'job':
        return <JobIcon width={48} height={64} style={{ color: 'var(--ant-color-primary)' }} />;
      case 'current-test':
        return <LabWorkIcon width={36} height={36} style={{ color: 'var(--ant-color-primary)' }} />;
      case 'lab-schedule':
        return <BeakerIcon width={36} height={36} style={{ color: 'var(--ant-color-primary)' }} />;
      case 'prev-lab-test':
        return <LabWorkIcon width={36} height={36} style={{ color: 'var(--ant-color-primary)' }} />;
      case 'disposition':
        return <DispositionIcon className="primary-text" />;
      case 'not-found':
        return <UserCardIcon style={{ color: 'var(--ant-color-primary)' }} />;
      case 'checkout-failure':
        return (
          <Icon
            icon={'RxCross2'}
            hasBackground
            bgColor={'var(--user-main-red)'}
            bgSize={'36px'}
            color="#fff"
            iconSize="1.7em"
          />
        );
      case 'coupons-not-found':
      case 'coupon-disbaled':
        return <Icon iconSize="3em" color={'var(--ant-color-primary)'} icon="CouponsIcon" />;
      case 'available-products':
        return <Icon iconSize={'3em'} fill={'var(--ant-color-primary)'} icon={'ProductIcon'} />;
      case 'product-variant':
        return <ProductVariantIcon style={{ color: 'var(--ant-color-primary)' }} />;
      case 'product':
        return (
          <div className="primary-text">
            <ProductsIcon width={40} height={40} />
          </div>
        );
      case 'stripe-element':
        return (
          <Icon
            icon={'RxCross2'}
            hasBackground
            bgColor={'var(--user-main-red)'}
            bgSize={'36px'}
            color="#fff"
            iconSize="1.7em"
          />
        );
      case 'verify-link-expired':
        return (
          <Icon
            icon={'RxCross2'}
            hasBackground
            bgColor={'var(--user-main-red-light)'}
            bgSize={'36px'}
            color={'var(--user-main-red)'}
            iconSize="1.7em"
          />
        );
      case 'already-verified-link':
        return (
          <Icon
            icon={'InfoIcon2'}
            hasBackground
            bgColor={'var(--user-primary-light)'}
            bgSize={'36px'}
            color={'var(--ant-color-primary)'}
            iconSize="1.7em"
          />
        );
      case 'verified-link':
        return (
          <Icon
            icon={'EmailIcon'}
            hasBackground
            bgColor={'var(--user-main-green-light'}
            bgSize={'36px'}
            color={'var(--user-main-green)'}
            iconSize="1.7em"
          />
        );
      case 'verify-link-notfound':
        return (
          <Icon
            icon={'RxCross2'}
            hasBackground
            bgColor={'var(--user-main-red-light)'}
            bgSize={'36px'}
            color={'var(--user-main-red)'}
            iconSize="1.7em"
          />
        );
      case 'payment-request':
        return <CardTickIcon className={'primary-text'} />;
      case 'lab-panel':
        return <MicroscopeIcon className={'primary-text'} />;
      case 'status-type':
        return <ListTickIcon width={32} height={32} className={'primary-text'} />;
      case 'firebase':
        return <img src="https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg" />;
      case 'message-template':
        return <FilesIcon height={32} width={32} className={'primary-text'} />;
      case 'waiting-for-provider':
        return (
          <div className={styles.waitingForProvider}>
            <FirstAidIcon />
          </div>
        );
      case 'leave':
        return <CalenderDashIcon className="primary-text" />;
      case 'pharmacy-prescription':
        return <PrescriptionCrossIcon className="primary-text" />;
      default:
        return <img src={noData} alt="" />;
    }
  };

  const title = () => {
    if (customTitle) return customTitle;
    switch (type) {
      case 'chat':
      case 'doctor-chat':
        return 'No Active Conversations';
      case 'notification':
        return 'No Notification yet';
      case 'admin-chat':
        return 'No Chat Found';
      case 'prescription':
        return 'No Prescription Available';
      case 'history':
        return 'No History Available';
      case 'current-order':
      case 'order':
      case 'lead-order':
        return 'No order found';
      case 'track':
        return 'No Order Journey';
      case 'before-refund':
      case 'after-refund':
        return 'Order Refunded';
      case 'before-cancel':
      case 'after-cancel':
        return 'Order Cancelled';
      case 'chart':
        return 'No Stats Available';
      case 'weight':
        return 'BMI Calculator';
      case 'faq':
        return 'No FAQ Found';
      case 'follow_up':
        return 'No Follow Up Found';
      case 'completed':
        return 'Order Completed';
      case 'case':
        return 'No case found';
      case 'lead-untrack-cases':
        return 'No untracked case found';
      case 'ticket':
        return 'No ticket found';
      case 'address':
        return 'No address found';
      case 'credits':
        return 'No credit found';
      case 'lab-records':
        return 'No lab records found';
      case 'lab-orders':
        return 'No lab orders found';
      case 'notes':
        return 'No notes';
      case 'appointments':
        return 'No appointments';
      case 'products':
        return 'No products';
      case 'activity':
        return 'No activity';
      case 'communication':
        return 'No communications';
      case 'job':
        return 'No Scheduled Job';
      case 'current-test':
        return 'No current test available';
      case 'prev-lab-test':
        return 'No tests applied yet';
      case 'not-found':
        return 'No Data Found';
      case 'checkout-failure':
        return 'Your checkout was canceled';
      case 'coupons-not-found':
        return 'No Product Coupon Added';
      case 'coupon-disbaled':
        return 'Coupons Disabled';
      case 'available-products':
        return 'No products found';
      case 'product-variant':
        return 'No Variants Found';
      case 'product':
        return 'No Products Found';
      case 'stripe-element':
        return 'Payment Processing Error';
      case 'verify-link-expired':
        return 'Link Expired';
      case 'already-verified-link':
        return 'Already Verified';
      case 'verified-link':
        return 'Email Verified';
      case 'verify-link-notfound':
        return 'Verification Not Found';
      case 'payment-request':
        return 'No Payment Requests Found';
      case 'lab-panel':
        return 'No Lab Avaiable';
      case 'disposition':
        return 'No Dispositions Added Yet';
      case 'status-type':
        return 'No Status Type Selected';
      case 'message-template':
        return 'No Template Added Yet';
      case 'waiting-for-provider':
        return 'Waiting for Provider';
      case 'leave':
        return 'No Leaves Yet';
      case 'pharmacy-prescription':
        return 'No Prescriptions Yet';
      default:
        return null;
    }
  };

  const desc = () => {
    if (customDesc) return customDesc;
    switch (type) {
      case 'chat':
        return "You haven't started any chat with your care team. Once you do, all conversations will appear here.";
      case 'admin-chat':
        return 'There is no active chat available right now.';
      case 'doctor-chat':
        return "You don't have any ongoing chats. Start a new conversation to connect with doctor.";
      case 'notification':
        return "We'll let you know when something pops up!";
      case 'prescription':
        return "You don't have any prescription details available.";
      case 'history':
        return 'We are unable to track your order at the moment. Please contact support for further assistance';
      case 'current-order':
      case 'order':
        return "You don't have any order. Place order or contact support for further assistance";
      case 'track':
        return 'This Charge does not require a journey';
      case 'before-refund':
      case 'before-cancel':
        return "After reviewing your information, the doctor was unable to approve your prescription at this time.<br /><br /> We will process a refund to the payment method on file within <b>3-5 business days</b>. You will receive a confirmation once the refund has been issued. <br /><br /> If you have any questions or need further assistance, please don't hesitate to reach out.";
      case 'after-refund':
      case 'after-cancel':
        return "After reviewing your information, the doctor was unable to approve your prescription at this time. <br /><br />We have processed your refund to the payment method on file. Please allow 3-5 business days for the funds to reflect in your account. You will receive a confirmation from your payment provider once the refund is completed.<br /><br />If you have any questions or need further assistance, please don't hesitate to reach out.";
      case 'chart':
        return 'Inadequate data to track weight history.';
      case 'weight':
        return 'Enter Your weight and height to calculate your Body Mass Index.';
      case 'completed':
        return `Your Order has been completed! If you have any questions, feel free to email us at ${getCurrentTenantSupportEmail() || 'support@joinelevate.com'} or contact us via call or text at +1 (833) 669-2112.`;
      case 'faq':
        return 'No results match your search in our FAQs.';
      case 'case':
        return 'Currently, there are no cases associated with this order charge. Please check again later';
      case 'lead-order':
        return 'Currently, there are no orders associated with this lead. Please check again later';
      case 'lead-untrack-cases':
        return 'Currently, there are no untracked cases associated with this lead';
      case 'ticket':
        return 'No support tickets yet. Create a new ticket to get started and manage your requests.';
      case 'address':
        return "This patient doesn't have any address on record. Please create a new one.";
      case 'credits':
        return "This patient doesn't have any credit on record.";
      case 'lab-records':
        return 'No lab records added yet.';
      case 'lab-orders':
        return "This patient doesn't have any lab orders yet. Please create a new one.";
      case 'follow_up':
        return 'No follow ups yet. Create a new Follow Up to get started.';
      case 'notes':
        return 'Add a note to get started';
      case 'appointments':
        return 'No appointments has been found yet';
      case 'products':
        return 'No product has been found yet';
      case 'activity':
        return 'No activity data found yet';
      case 'communication':
        return 'No communications has been found yet';
      case 'job':
        return 'No Scheduled Job has been found yet';
      case 'current-test':
        return 'Select lab test from homepage to get started';
      case 'prev-lab-test':
        return 'Start by applying for a lab test';
      case 'checkout-failure':
        return 'It looks like you didn’t complete your purchase. Don’t worry — your order hasn’t been placed yet.';
      case 'coupons-not-found':
        return 'Add Product Coupon';
      case 'coupon-disabled':
        return 'Toggle on to view all coupons';
      case 'available-products':
        return 'No products added yet. Add new product to manage it';
      case 'product-variant':
        return 'No variants added yet. Please add new variants to view details';
      case 'product':
        return 'No products match your search';
      case 'stripe-element':
        return 'Payment Gateway problem , please contact support for further assistance';
      case 'verify-link-expired':
        return 'The verification link is invalid or has expired. For security reasons, verification links are only valid for 24 hours.';
      case 'already-verified-link':
        return 'This email address has already been verified in our system. No further action is required.';
      case 'verified-link':
        return 'Thank you! Your email has been successfully verified. You can now access all features of your account.';
      case 'verify-link-notfound':
        return 'The verification link is invalid.';
      case 'payment-request':
        return 'There are no payment requests available at the moment.';
      case 'lab-panel':
        return 'There are currently no provider labs available for this patient';
      case 'disposition':
        return "You haven't added any dispositions yet. Add one to organize statuses and streamline your workflow.";
      case 'status-type':
        return 'Select a status type from the dropdown above to view and reorder its statuses.';
      case 'message-template':
        return 'Create reusable message templates to quickly respond to patients. Once added, it will appear here for easy access.';
      case 'waiting-for-provider':
        return "Your information has been sent to our care team. We've received your information and a provider will review it and message you here about your treatment and prescription.";
      case 'leave':
        return "You haven't applied for any leave. Plan your time off and apply here when needed.";
      case 'pharmacy-prescription':
        return 'Prescriptions will appear here once they have been created.';
      default:
        return null;
    }
  };

  if (alignIcon === 'right') {
    return (
      <Flex justify="space-between" align="center">
        <Flex gap={4} vertical align="start" justify="start">
          <div className={titleClassName}>{title()}</div>
          <div style={{ color: 'var(--user-main-text)' }} className={descClassName}>
            <div dangerouslySetInnerHTML={{ __html: desc() }} />
          </div>
          <Flex justify="center" style={{ width: '100%' }} className="mt-4 hide-on-large">
            <div className="hide-on-large">{icon()}</div>
          </Flex>
        </Flex>
        <div className="hide-on-small">{icon()}</div>
      </Flex>
    );
  }

  if (alignIcon === 'left') {
    return (
      <Flex className="mt-1" align="center" gap={24}>
        {icon()}
        <Flex vertical gap={4}>
          <div className="body-medium">{title()}</div>
          <div style={{ color: 'var(--user-main-text)' }} className={descClassName}>
            <div dangerouslySetInnerHTML={{ __html: desc() }} />
          </div>
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex className="mt-1" justify="center" align="center" vertical gap={customGap ?? 24}>
      {icon()}
      <Flex justify="center" align="center" vertical gap={2}>
        <div style={{ textAlign: 'center' }} className={titleClassName}>
          {title()}
        </div>
        <div style={{ color: 'var(--user-main-text)', textAlign: 'center' }} className={descClassName}>
          <div dangerouslySetInnerHTML={{ __html: desc() }} />
        </div>
        <IF condition={extraItems()}>
          <div className="mt-4">{extraItems()}</div>
        </IF>
      </Flex>
      {extraButton()}
    </Flex>
  );
};

export default Unavailable;
